import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Separator } from '@/components/ui/separator';
import { ChannelGuideForm } from './channelGuideForm';
import { ChannelGuide } from '@/lib/schema/channelGuide';
import { createChannelGuide } from '@/lib/api/channelGuide';
import { createTask } from '@/lib/api/task';
import { Command } from '../tv-controllers';

async function submitChannelGuide(data: ChannelGuide) {
  const channelGuideId = await createChannelGuide(data);

  if (data.pin !== '' && data.suiteId !== '') {
    createTask({
      boxes: [],
      data: {
        channelGuideId,
        pin: data.pin,
        suiteId: data.suiteId,
      },
      command: Command.IMPORT_CHANNEL_GUIDE as any,
      isTvControllerTask: true,
    });
  }
}

export default function CreateChannelGuide() {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: submitChannelGuide,
    onSuccess: () => {
      navigate('/channel-guides');
    },
    onError: (error) => {
      console.error('Error creating TV controller:', error);
    },
  });

  const onSubmit = (data: any) => {
    mutation.mutate(data);
  };

  return (
    <div className="w-full pb-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Create channel guide</h1>
        </div>
      </div>

      <Separator className="my-6" />

      <ChannelGuideForm mutation={mutation} onSubmit={onSubmit} />
    </div>
  );
}
